import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseInterface } from '../interface/auth';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  public POST(url: string, payload: any): Observable<ApiResponseInterface> {
    return this.http.post<ApiResponseInterface>(`${environment.API_BASE_URL}${url}`, payload).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      }),
    );
  }

  public GET(url: string): Observable<ApiResponseInterface> {
    return this.http.get<ApiResponseInterface>(`${environment.API_BASE_URL}${url}`).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      }),
    );
  }

  public DELETE(url: string): Observable<ApiResponseInterface> {
    return this.http.delete<ApiResponseInterface>(`${environment.API_BASE_URL}${url}`).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      }),
    );
  }

  public PATCH(url: string, payload: any): Observable<ApiResponseInterface> {
    return this.http.patch<ApiResponseInterface>(`${environment.API_BASE_URL}${url}`, payload).pipe(
      switchMap((response: any) => of(response)),
      catchError((error: any) => {
        return throwError(() => error);
      }),
    );
  }
  

}
